import Applications from './Applications'
import Show from './Show'

export default {
    Applications,
    Show
}
